/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { AddUpdateCourts } from "../../sub-modules"
import { GetCourtsDetail, UpdateCourts } from "../../utilities/api/courts";
import { CourtDetailType } from "../../utilities/types";
import { ToastContainer, toast } from "react-toastify";


const UpdateCourt = () => {
    const location = useLocation()
    let id = location.state
    const navigate = useNavigate()
    const [key, setKey] = useState()
    const [courtData, setCourtData] = useState<CourtDetailType>({
        name: "",
        facilityId: 1,
        sportId: "",
        openTime: "",
        closeTime: "",
        preBookingMaxDays: 0,
        isActive: "true",
        rates: []
    })
    const [submitButton, setSubmitButton] = useState(false)

    const handleCreateUpdate = async (payload: any) => {
        setSubmitButton(true)
        const result = await UpdateCourts(id, payload)
        if (result.status === 200) {
            navigate("/courts")
        }
        else {
            toast.error(result.response.data.message)
        }
        setSubmitButton(false)
    }

    const GetInfo = async () => {
        const result = await GetCourtsDetail(id)
        if (result.statusCode === 200) {
            setKey(result.data.id)
            setCourtData({
                name: result.data.name,
                facilityId: result.data.facility.id,
                sportId: result.data.sport.id,
                openTime: result.data.openTime,
                closeTime: result.data.closeTime,
                preBookingMaxDays: result.data.preBookingMaxDays,
                isActive: result.data.isActive,
                rates: result.data.courtRates.map((item: any) => {
                    return ({
                        rateId: item.id,
                        ratePerSlot: item.ratePerSlot,
                        startTime: item.startTime,
                        endTime: item.endTime
                    })
                })
            })
        }
    }


    useEffect(() => {
        GetInfo()
    }, [])

    return (
        <>
            <AddUpdateCourts key={key} id={id} name="Edit Court" courtData={courtData} setCourtData={setCourtData} handleCreateUpdate={handleCreateUpdate} submitButton={submitButton} />
            <ToastContainer />
        </>
    )
}
export { UpdateCourt }
